export const actionTypes = {
  GET_VALIDATION_RULES: "GET_VALIDATION_RULES",
  SET_VALIDATION_RULES: "SET_VALIDATION_RULES",
  GET_VALIDATION_RULE_BY_ID: "GET_VALIDATION_RULE_BY_ID",
  SET_VALIDATION_RULE_BY_ID: "SET_VALIDATION_RULE_BY_ID",
  EDIT_VALIDATION_RULE_FORM_CHANGE: "EDIT_VALIDATION_RULE_FORM_CHANGE",
  UPDATE_VALIDATION_RULE: "UPDATE_VALIDATION_RULE"
};

export const actions = {
  getValidationRules: (payload) => ({
    type: actionTypes.GET_VALIDATION_RULES,
    payload: payload,
  }),

  setValidationRules: (data) => ({
    type: actionTypes.SET_VALIDATION_RULES,
    payload: data,
  }),

  getValidationRulesById: (payload) => ({
    type: actionTypes.GET_VALIDATION_RULE_BY_ID,
    payload: payload,
  }),

  setValidationRulesById: (payload) => ({
    type: actionTypes.SET_VALIDATION_RULE_BY_ID,
    payload: payload,
  }),

  setValidationRuleEditForm: (payload) => ({
    type: actionTypes.EDIT_VALIDATION_RULE_FORM_CHANGE,
    payload: payload,
  }),

  updateValidationRule: (payload) => ({
    type: actionTypes.UPDATE_VALIDATION_RULE,
    payload
  }),
};
